// extracted by mini-css-extract-plugin
module.exports = {"desktop-up":"(min-width: calc(1280 * 1px))","item":"StickersListItem_item__2YPbC","img":"StickersListItem_img__3bvBK"};